






















import { Component, Vue } from "vue-property-decorator";
import { IDialog } from "@/lib/interfaces/dialog.interface";
import ConfirmActionDialog from "../utility/ConfirmActionDialog.vue";

@Component({
  components: { ConfirmActionDialog }
})
export default class FleetCostCenterSelectorDialog extends Vue implements IDialog {
  isDialog = false;
  selected: string[] = [];
  costCenterInput = "";

  open(currentIds: string[] = []): void {
    this.selected = Array.isArray(currentIds) ? [...currentIds] : [];
    this.costCenterInput = this.selected.length > 0 ? this.selected[0] : "";
    this.isDialog = true;
  }

  close(): void {
    this.isDialog = false;
  }

  confirmSelection(): void {
    const enteredCostCenterId = this.costCenterInput?.trim();

    if (!enteredCostCenterId) {
      this.$emit("confirm", []);
      this.isDialog = false;
      return;
    }

    const payload = [{ id: enteredCostCenterId, name: enteredCostCenterId }];

    this.$emit("confirm", [{ ...payload[0] }]);
    this.isDialog = false;
  }
}
